import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_DOCTOR_APPOINTMENTS } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// A fee the admin approved on the registration review comes back as PRE_APPROVED
// until the doctor's registration itself is approved (only then can patients
// book it). To the doctor it is simply approved, so show it that way.
const REGISTRATION_PRE_APPROVED_STATUS = "PRE_APPROVED";
const normalizeFeeStatuses = (fees) => {
  if (!fees || typeof fees !== "object") return fees;
  return Object.fromEntries(
    Object.entries(fees).map(([key, fee]) => [
      key,
      fee?.status === REGISTRATION_PRE_APPROVED_STATUS
        ? { ...fee, status: "APPROVED" }
        : fee,
    ]),
  );
};

// API: GET /api/v1/consultation/doctor/consultation-fees
export const fetchDoctorConsultationPricingReducer = createAsyncThunk(
  ACTION_DOCTOR_APPOINTMENTS.fetch_doctor_consultation_pricing,
  async (_, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getDoctorConsultationFees}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        console.log("Consultation Fees Response:", response.data.data);
        return normalizeFeeStatuses(response.data.data);
      } else {
        const msg =
          response?.data?.message ||
          i18n.t("toast.failedToFetchDoctorConsultationFees");
        // Don't show error toast for empty data
        if (response?.status !== 200) {
          toast.error(msg);
        }
        return rejectWithValue(msg);
      }
    } catch (error) {
      console.error("Error fetching consultation fees:", error);
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorFetchingConsultationFees");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
